import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    Form,
    FormGroup,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Input,
    FormFeedback,
    Button,
    Alert
} from 'reactstrap';

import {
    zones__checkpointCreate,
    zones_dismissZoneAlert
} from 'redux/actions/zones'
import { connect } from 'react-redux';


class CheckpointCreator extends Component {
    static propTypes = {
        dispatch: PropTypes.func,
        zoneId: PropTypes.number,
        alert: PropTypes.object
    }

    constructor(props) {
        super(props)
        this.state = {
            seq: '',
            serial: '',
            name: '',
            lat: '',
            lng: '',

            isAlert: false,
            alertField: null,
            alertMsg: ''
        }
    }

    createNewSection = () => {
        const { dispatch, zoneId } = this.props
        const { seq, serial, name, lat, lng } = this.state
        if (seq === '') {
            return this.setState({
                alertField: 'seq',
                isAlert: true,
                alertMsg: 'This field is required'
            })
        }
        if (serial === '') {
            return this.setState({
                alertField: 'serial',
                isAlert: true,
                alertMsg: 'This field is required'
            })
        }
        if (name === '') {
            return this.setState({
                alertField: 'name',
                isAlert: true,
                alertMsg: 'This field is required'
            })
        }
        if (lat === '') {
            return this.setState({
                alertField: 'lat',
                isAlert: true,
                alertMsg: 'This field is required'
            })
        }
        if (lng === '') {
            return this.setState({
                alertField: 'lng',
                isAlert: true,
                alertMsg: 'This field is required'
            })
        }
        let point = {
            seq: seq,
            serialNumber: serial.toUpperCase(),
            name: name,
            lat: lat,
            lng: lng
        }
        dispatch(zones__checkpointCreate(zoneId, point))
    }
    onDimissAlert = () => {
        const { dispatch, alert } = this.props
        dispatch(zones_dismissZoneAlert(alert._point.id, '_point'))
    }
    onFocus = () => {
        const { isAlert, alertField } = this.state;
        const { alert } = this.props;

        if (isAlert && alertField === 'seq') {
            this.setState({ isAlert: false, alertField: null, alertMsg: '' })
        }
        if (alert._point.id === 'seq') {
            this.onDimissAlert();
        }

        if (isAlert && alertField === 'serial') {
            this.setState({ isAlert: false, alertField: null, alertMsg: '' })
        }
        if (alert._point.id === 'serial') {
            this.onDimissAlert();
        }

        if (isAlert && alertField === 'name') {
            this.setState({ isAlert: false, alertField: null, alertMsg: '' })
        }
        if (alert._point.id === 'name') {
            this.onDimissAlert();
        }

        if (isAlert && alertField === 'lat') {
            this.setState({ isAlert: false, alertField: null, alertMsg: '' })
        }
        if (alert._point.id === 'lat') {
            this.onDimissAlert();
        }

        if (isAlert && alertField === 'lng') {
            this.setState({ isAlert: false, alertField: null, alertMsg: '' })
        }
        if (alert._point.id === 'lng') {
            this.onDimissAlert();
        }
    }

    render() {
        const { alert, zoneId } = this.props
        const {
            seq,
            serial,
            name,
            lat,
            lng,
            isAlert,
            alertField,
            alertMsg
        } = this.state

        let seqInvalid = false;
        let seqMsg = '';
        if (isAlert && alertField === 'seq') {
            seqInvalid = true
            seqMsg = alertMsg
        }
        if (alert._point.zone === zoneId && alert._point.id === 'seq' && alert._point.invalid) {
            seqInvalid = true
            seqMsg = alert._point.message
        }

        let serialInvalid = false;
        let serialMsg = '';
        if (isAlert && alertField === 'serial') {
            serialInvalid = true
            serialMsg = alertMsg
        }
        if (alert._point.zone === zoneId && alert._point.id === 'serial' && alert._point.invalid) {
            serialInvalid = true
            serialMsg = alert._point.message
        }

        let nameInvalid = false;
        let nameMsg = '';
        if (isAlert && alertField === 'name') {
            nameInvalid = true
            nameMsg = alertMsg
        }
        if (alert._point.zone === zoneId && alert._point.id === 'name' && alert._point.invalid) {
            nameInvalid = true
            nameMsg = alert._point.message
        }

        let latInvalid = false;
        let latMsg = '';
        if (isAlert && alertField === 'lat') {
            latInvalid = true
            latMsg = alertMsg
        }
        if (alert._point.zone === zoneId && alert._point.id === 'lat' && alert._point.invalid) {
            latInvalid = true
            latMsg = alert._point.message
        }

        let lngInvalid = false;
        let lngMsg = '';
        if (isAlert && alertField === 'lng') {
            lngInvalid = true
            lngMsg = alertMsg
        }
        if (alert._point.zone === zoneId && alert._point.id === 'lng' && alert._point.invalid) {
            lngInvalid = true
            lngMsg = alert._point.message
        }

        let successAlertOpen = false
        let failAlertOpen = false
        let submitAlertMessage = ''
        if (alert._point.zone === zoneId && alert._point.id === 'success' && alert._point.valid) {
            successAlertOpen = true
            submitAlertMessage = alert._point.message
        }
        if (alert._point.zone === zoneId && alert._point.id === 'fail' && alert._point.invalid) {
            failAlertOpen = true
            submitAlertMessage = alert._point.message
        }

        return (
            <div>
                <Form onSubmit={(e) => { e.preventDefault() }}>
                    <FormGroup>
                        <Row>
                            <Col xs='12' md='2' style={{ marginTop: '5px' }}>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        # :
                                    </InputGroupAddon>
                                    <Input
                                        invalid={seqInvalid}
                                        type='number'
                                        value={seq}
                                        onChange={(e) => this.setState({ seq: e.target.value })}
                                        onFocus={this.onFocus}
                                    />
                                    <FormFeedback onClick={this.onFocus} valid className="text-center"> {seqMsg}</FormFeedback>
                                    <FormFeedback onClick={this.onFocus} className="text-center">{seqMsg}</FormFeedback>
                                </InputGroup>
                            </Col>
                            <Col xs='12' md='5' style={{ marginTop: '5px' }}>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Latitude :
                                    </InputGroupAddon>
                                    <Input
                                        invalid={latInvalid}
                                        value={lat}
                                        type='number'
                                        onChange={(e) => this.setState({ lat: e.target.value })}
                                        onFocus={this.onFocus}
                                    />
                                    <FormFeedback onClick={this.onFocus} valid className="text-center"> {latMsg}</FormFeedback>
                                    <FormFeedback onClick={this.onFocus} className="text-center">{latMsg}</FormFeedback>
                                </InputGroup>
                            </Col>
                            <Col xs='12' md='5' style={{ marginTop: '5px' }}>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Longitude :
                                    </InputGroupAddon>
                                    <Input
                                        invalid={lngInvalid}
                                        value={lng}
                                        type='number'
                                        onChange={(e) => { this.setState({ lng: e.target.value }) }}
                                        onFocus={this.onFocus}
                                    />
                                    <FormFeedback onClick={this.onFocus} valid className="text-center"> {lngMsg}</FormFeedback>
                                    <FormFeedback onClick={this.onFocus} className="text-center">{lngMsg}</FormFeedback>
                                </InputGroup>
                            </Col>

                            <Col xs='12' md='6' style={{ marginTop: '5px' }}>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Serial :
                                    </InputGroupAddon>
                                    <Input
                                        style={{ textTransform: 'uppercase' }}
                                        invalid={serialInvalid}
                                        value={serial}
                                        onChange={(e) => this.setState({ serial: e.target.value })}
                                        onFocus={this.onFocus}
                                    />
                                    <FormFeedback onClick={this.onFocus} valid className="text-center"> {serialMsg}</FormFeedback>
                                    <FormFeedback onClick={this.onFocus} className="text-center">{serialMsg}</FormFeedback>
                                </InputGroup>
                            </Col>
                            <Col xs='12' md='6' style={{ marginTop: '5px' }}>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Name :
                                    </InputGroupAddon>
                                    <Input
                                        invalid={nameInvalid}
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                        onFocus={this.onFocus}></Input>
                                    <FormFeedback onClick={this.onFocus} valid className="text-center"> {nameMsg}</FormFeedback>
                                    <FormFeedback onClick={this.onFocus} className="text-center">{nameMsg}</FormFeedback>
                                </InputGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
                <div className='text-right mb-3'>
                    <Button
                        onClick={this.createNewSection}
                        color="secondary"
                        size="sm">
                        <span className="hover-opa">Insert New Checkpoint{' '}<i className="icon-plus"></i></span>
                    </Button>{' '}
                </div>
                <div className='text-center my-3'>
                    <Alert color="success" isOpen={successAlertOpen} toggle={this.onDimissAlert}>
                        {submitAlertMessage}
                    </Alert>
                    <Alert color="danger" isOpen={failAlertOpen} toggle={this.onDimissAlert}>
                        {submitAlertMessage}
                    </Alert>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        dispatch: store.dispatch,
        alert: store.zones.alert
    }
}
export default connect(
    mapStateToProps
)(CheckpointCreator)


// WEBPACK FOOTER //
// ./src/components/features/CheckpointCreator/CheckpointCreator.js